module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-300.cc9f2dc0.woff2";